module.exports = __webpack_public_path__ + "img/dni-dorso.238c9f83.svg";